import React, { useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { Routes } from '../../utils/Routes';
import { APIs } from '../../utils/Constants';
import AboutImg from '../../assets/images/Nav/About.png';
import ArtImg from '../../assets/images/Nav/Art.png';
import ThingsImg from '../../assets/images/Nav/Things.png';
import ThoughtsImg from '../../assets/images/Nav/Thoughts.png';
import MusicImg from '../../assets/images/Nav/Music.png';
import ContactImg from '../../assets/images/Nav/Contact.png';
import SiteIcon from '../../assets/images/SiteIcon.png';

const NavIcons: { route: string; title: string; src: string }[] = [
  { route: Routes.About, title: 'About', src: AboutImg },
  { route: Routes.Art, title: 'Art', src: ArtImg },
  { route: Routes.Thoughts, title: 'Thoughts', src: ThoughtsImg },
  { route: Routes.Things, title: 'Things', src: ThingsImg },
  { route: Routes.Music, title: 'Music', src: MusicImg },
  { route: Routes.Contact, title: 'Contact', src: ContactImg },
];

// Community Signup Component
const CommunityIcon = ({ isMobile = false }: { isMobile?: boolean }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const GOOGLE_SCRIPT_URL =
        'https://script.google.com/macros/s/AKfycbyjvXXN48P32KXCDq274z0HzRlReDDj05D4gy_ewmF0LWpLuolIjYu0cchks8KzB770/exec';

      await Promise.all([
        fetch(GOOGLE_SCRIPT_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            timestamp: new Date().toISOString(),
            source: 'unspoken_community_signup',
          }),
        }),
        axios.post(
          process.env.REACT_APP_UNSPOKEN_SERVICES_API + APIs.communitySignup,
          { email },
        ),
      ]);

      setSubmitted(true);
      setTimeout(() => {
        setEmail('');
        setSubmitted(false);
        setIsOpen(false);
      }, 5000);
    } catch (err) {
      setError('Unable to subscribe right now. Please try again later.');
      console.error('Subscription error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isMobile) {
    return (
      <div>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full py-3 px-2 text-sm text-gray-400 hover:text-custom-stone transition-colors duration-200 flex items-center justify-between"
        >
          <span className="flex items-center gap-2.5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            Join Community
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        {isOpen && (
          <div className="px-6 pb-6 bg-gray-950/50">
            {isSubmitting ? (
              <div className="py-8 flex flex-col items-center justify-center space-y-4">
                <div className="relative w-16 h-16">
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-4 h-4 bg-custom-stone rounded-full z-10"></div>
                  </div>
                  <div className="absolute inset-0 rounded-full border border-custom-stone/40 animate-[ping_2s_ease-in-out_infinite]"></div>
                  <div
                    className="absolute inset-0 rounded-full border border-custom-stone/30 animate-[ping_2s_ease-in-out_infinite]"
                    style={{ animationDelay: '0.5s' }}
                  ></div>
                  <div
                    className="absolute inset-0 rounded-full border border-custom-stone/20 animate-[ping_2s_ease-in-out_infinite]"
                    style={{ animationDelay: '1s' }}
                  ></div>
                  <div
                    className="absolute inset-0 animate-spin"
                    style={{ animationDuration: '3s' }}
                  >
                    <div className="absolute top-0 left-1/2 w-2 h-2 bg-custom-stone/60 rounded-full -translate-x-1/2"></div>
                  </div>
                  <div
                    className="absolute inset-0 animate-spin"
                    style={{ animationDuration: '3s', animationDelay: '1s' }}
                  >
                    <div className="absolute top-0 left-1/2 w-2 h-2 bg-custom-stone/60 rounded-full -translate-x-1/2"></div>
                  </div>
                  <div
                    className="absolute inset-0 animate-spin"
                    style={{ animationDuration: '3s', animationDelay: '2s' }}
                  >
                    <div className="absolute top-0 left-1/2 w-2 h-2 bg-custom-stone/60 rounded-full -translate-x-1/2"></div>
                  </div>
                </div>
              </div>
            ) : submitted ? (
              <div className="text-center py-6">
                <svg
                  className="w-10 h-10 mx-auto text-custom-stone mb-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p className="text-sm text-custom-stone mb-1">
                  See you on the other side!
                </p>
                <p className="text-xs text-gray-500">
                  Check your inbox for what comes next.
                </p>
              </div>
            ) : (
              <div className="mt-4">
                <p className="text-xs text-custom-stone mb-0.5">Get Updates</p>
                <p className="text-xs text-gray-500 mb-4">
                  When I make something worth interrupting your inbox for
                </p>
                <form onSubmit={handleSubmit} className="space-y-3">
                  {error && <p className="text-xs text-red-400">{error}</p>}
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                    className="w-full px-4 py-2.5 bg-black/50 border border-gray-700 rounded-lg focus:outline-none focus:border-custom-stone transition-colors duration-200 text-sm text-white placeholder-gray-600"
                  />
                  <button
                    type="submit"
                    className="w-full px-4 py-2.5 bg-custom-stone text-black rounded-lg font-medium text-sm transition-all duration-200 hover:opacity-90 active:scale-95"
                  >
                    Join →
                  </button>
                </form>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  // Desktop version - dropdown
  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-gray-400 hover:text-custom-stone transition-colors duration-200 p-1.5"
        aria-label="Join the community"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-5 h-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full right-0 mt-3 w-72 bg-gray-950 text-white rounded-xl shadow-2xl p-5 z-50 border border-gray-800">
            <p className="text-xs text-custom-stone mb-0.5">Get Updates</p>
            <p className="text-xs text-gray-500 mb-4">
              When I make something worth interrupting your inbox for
            </p>

            {isSubmitting ? (
              <div className="py-8 flex items-center justify-center">
                <div className="relative w-14 h-14">
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-3 h-3 bg-custom-stone rounded-full z-10"></div>
                  </div>
                  <div className="absolute inset-0 rounded-full border border-custom-stone/40 animate-[ping_2s_ease-in-out_infinite]"></div>
                  <div
                    className="absolute inset-0 rounded-full border border-custom-stone/20 animate-[ping_2s_ease-in-out_infinite]"
                    style={{ animationDelay: '0.7s' }}
                  ></div>
                </div>
              </div>
            ) : submitted ? (
              <div className="text-center py-4">
                <svg
                  className="w-10 h-10 mx-auto text-custom-stone mb-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p className="text-sm text-custom-stone">
                  See you on the other side!
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  Check your inbox for what comes next
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-2.5">
                {error && <p className="text-xs text-red-400">{error}</p>}
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="w-full px-3 py-2 bg-black/60 border border-gray-700 rounded-lg focus:outline-none focus:border-custom-stone transition-colors duration-200 text-sm text-white placeholder-gray-600"
                />
                <button
                  type="submit"
                  className="w-full px-4 py-2 bg-custom-stone text-black rounded-lg font-medium text-sm hover:opacity-90 active:scale-95 transition-all duration-200"
                >
                  Join →
                </button>
              </form>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (route: string) =>
    route === Routes.Home ? pathname === route : pathname.startsWith(route);

  return (
    <header className="bg-black/95 backdrop-blur-md border-b border-white/5 text-white fixed w-full z-30">
      <div className="container mx-auto px-6 py-3 flex justify-between items-center">
        {/* Logo */}
        <Link
          to={Routes.Home}
          className="flex items-center gap-2.5 group shrink-0"
        >
          <img
            src={SiteIcon}
            alt="Unspoken Creations"
            className="h-8 w-8 object-cover shadow-md ring-1 ring-white/20 group-hover:scale-105 transition-transform duration-200"
          />
          <div>
            <span className="font-semibold text-base tracking-tight text-white block leading-tight">
              Unspoken Creations
            </span>
            <span className="text-[10px] text-custom-stone/70 tracking-widest uppercase leading-tight hidden sm:block">
              Art · Thoughts · Music · Things
            </span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-1">
          {NavIcons.map(({ route, title, src }) => {
            const active = isActive(route);
            return (
              <Link
                key={title}
                to={route}
                aria-label={title}
                className="group relative p-2 transition-colors duration-200"
              >
                <img
                  src={src}
                  alt={title}
                  className={`w-5 h-5 object-cover rounded-sm transition-all duration-200 ${
                    active
                      ? 'opacity-100 ring-1 ring-custom-stone/50 rounded'
                      : 'opacity-50 group-hover:opacity-100'
                  }`}
                />
                {active && (
                  <span className="absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-custom-stone" />
                )}
                <span className="absolute top-full left-1/2 -translate-x-1/2 mt-1.5 px-2 py-1 bg-gray-900 border border-gray-800 text-white text-[10px] tracking-wide rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                  {title}
                </span>
              </Link>
            );
          })}
          <div className="w-px h-4 bg-gray-800 mx-2" />
          <CommunityIcon />
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-gray-400 hover:text-white focus:outline-none p-1.5 transition-colors duration-200"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={
                isMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'
              }
            />
          </svg>
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden fixed left-0 top-[53px] w-full h-[calc(100vh-53px)] bg-black z-40 overflow-y-auto flex flex-col">
          {/* Nav Links */}
          <nav className="flex flex-col items-center justify-start gap-1 pt-4 pb-6 px-6">
            {NavIcons.map(({ title, route, src }) => {
              const active = isActive(route);
              return (
                <Link
                  key={title}
                  to={route}
                  onClick={() => setIsMenuOpen(false)}
                  className={`group flex items-center gap-4 w-full max-w-xs py-3.5 transition-colors duration-200 ${
                    active
                      ? 'text-custom-stone'
                      : 'text-gray-300 hover:text-custom-stone'
                  }`}
                >
                  <img
                    src={src}
                    alt={title}
                    className={`w-7 h-7 object-cover rounded-sm transition-all duration-200 ${
                      active
                        ? 'opacity-100 ring-1 ring-custom-stone/50'
                        : 'opacity-60 group-hover:opacity-100'
                    }`}
                  />
                  <span className="text-lg font-light">{title}</span>
                </Link>
              );
            })}
          </nav>

          {/* Divider */}
          <div className="flex items-center gap-4 px-10">
            <div className="flex-1 h-px bg-gray-800" />
            <span className="text-[10px] uppercase tracking-widest text-gray-600">
              Community
            </span>
            <div className="flex-1 h-px bg-gray-800" />
          </div>

          {/* Community Signup */}
          <div className="px-6 py-6 max-w-sm mx-auto w-full">
            <CommunityIcon isMobile={true} />
          </div>
        </div>
      )}
    </header>
  );
}
